import { BigDecimal } from 'effect';

import { getCurrencyFormatConfig } from '../../../../config/currency';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../utils/intl';

import type { PriceWithCurrency } from '@vs-shop/schemas/primitive/priceWithCurrency';

export type FormatOptions = {
  readonly minimumFractionDigits?: number;
  readonly maximumFractionDigits?: number;
};

export type IntlMoneyBaseProps = {
  readonly value: PriceWithCurrency;
  readonly options?: FormatOptions;
};

export function IntlMoneyNew({ value, options }: IntlMoneyBaseProps) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();
  const config = getCurrencyFormatConfig(value.currency);

  return intl.formatNumber(BigDecimal.toNumberUnsafe(value.price), {
    style: 'currency',
    currency: value.currency,
    minimumFractionDigits: options?.minimumFractionDigits ?? config.decimals,
    maximumFractionDigits: options?.maximumFractionDigits ?? config.decimals,
  });
}
